/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Indonesia language
 *
 * @file id.js
 * @author Manimaran.S
 */

const id = {
  'popularChannelSlider.allChannels': 'Semua Kanal',
  'popularChannelSlider.recommended': 'Direkomendasikan',
  'hero.myetextbook.link': 'perpustakaan',
  'hero.myetextbook.text': 'Bukan judul yang tepat? Akses buku eText Anda',
  'hero.etextfeaturestitle': 'Temukan materi belajar di buku eText Anda',
  'hero.etextfeaturesdescription': 'Buku eText Anda disertai dengan materi belajar yang dirancang untuk membantu Anda berhasil. Belajar dengan flashcard dan lainnya tepat di buku eText Anda.',
  'aichat.title1': 'Dapatkan bantuan berbasis AI untuk apa saja terkait buku eText Anda.',
  'aichat.chatDesc1': 'Tulis pertanyaan untuk memulai',
  'subscriptiontext.isSubscribed': 'Bagian langganan Anda',
  'subscriptiontext.nonSubscriber': 'Tingkatkan untuk akses penuh',
  'topicConatiner.otherHeader': 'Video dan latihan terkait',
  'topicConatiner.exactLiteHeader': 'Konsep dan latihan terkait',
  'moremenu.downloadApp': 'Unduh aplikasinya',
  'moremenu.downloadAppAlreadyDownload': '%Click here% untuk mengunduh aplikasi di perangkat lain dan masuk secara otomatis atau untuk menggunakan kode QR unik untuk masuk dengan aman di aplikasi yang sudah Anda instal.',
  'moremenu.downloadAppNotDownload': '%Click here% untuk mengunduh aplikasi dan masuk dengan aman menggunakan kode QR unik Anda',
  'channel.noBundletitle': 'Gunakan Persiapan Belajar untuk mata pelajaran terkait & lainnya',
  'onboard.studyPlan': 'Rencana belajar khusus dibuat!',
  'onboard.addCourseAnother': 'Anda ingin menambahkan mata pelajaran lain?',
  'onboard.purchase': 'Saya perlu membeli Buku eText Pearson',
  'onboard.addCourseWithoutEtext': 'Tambahkan mata pelajaran menggunakan Persiapan Belajar',
  'onboard.mayBeLater': 'Mungkin nanti',
  'onboard.aboutCourse': 'Beri tahu kami tentang kursus Anda',
  'onboard.close': 'Tutup',
  'course.addTitle': 'Tambahkan kursus',
  'common.PURCHASE': 'Pembelian',
  'common.CLOSE': 'Tutup',
  'open': 'buka',
  'continue': 'Lanjutkan',
  'yes': 'Ya',
  'no': 'Tidak',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Berhasil!',
  'courses.toc.PUBLISH_MESSAGE': 'Siswa hanya akan melihat perubahan Anda saat mereka membuka konten nanti.',
  'errors.GENERIC_TITLE': 'Anda tidak memiliki akses saat ini',
  'errors.GENERIC_DESC': 'Pertama, muat ulang atau hapus cache. Jika itu tidak berhasil, hubungi ',
  'errors.GENERIC_LINK': 'dukungan Pearson.',
  'errors.GENERIC_CODE': 'Kode kesalahan: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Langganan Tidak Ditemukan',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Akun Anda tidak mencakup akses ke judul ini. Jika Anda pikir Anda menerima pesan ini karena kesalahan,\n      silakan hubungi Dukungan Teknis Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Langganan Tidak Ditemukan',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Langganan Anda tidak mencakup akses ke eText, akan tetapi Anda dapat berlangganan eText sekarang \n    menggunakan kartu kredit.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Akun saya',
  'menu.helpCenter': 'Pusat Bantuan',
  'menu.preferencesCenter': 'Pusat Preferensi',
  'menu.CONTACT_SUPPORT': 'Hubungi Dukungan',
  'menu.HELP_SUPPORT': 'Bantuan & dukungan',
  'menu.FAQS': 'Tanya-Jawab',
  'menu.CHAT_WITH_SUPPORT': 'Bicara dengan tim dukungan',
  'menu.OTP_CODES': 'Kode OTP',
  'menu.LAUNCH_CODE': 'Luncurkan log kode',
  'menu.SEND_CODE': 'Kirim kode baru ke pengguna via email',
  'menu.SEND_CODE_PHONE': 'Kirim kode baru ke pengguna via SMS',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Pemberitahuan Privasi',
  'menu.TITLE_INFO': 'Info Judul',
  'menu.PEARSON_ACCESSIBILITY': 'Aksesibilitas Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Daftarkan {deviceLimit} perangkat. Ganti 1 dalam sebulan.',
  'menu.ACCESSIBILITY': 'Aksesibilitas',
  'menu.ACCESSIBILITY_SUPPORT': 'Dukungan aksesibilitas',
  'menu.DEVICES': 'Perangkat terbaru',
  'menu.THIS_DEVICE': 'Perangkat ini',
  'menu.GET_THE_APP_DOWNLOAD': 'Unduh aplikasi seluler',
  'menu.MOJO_APP_INFO': 'Kunjungi app store di ponsel atau tablet Anda untuk menggunakan Pearson+ secara offline.',
  'menu.DEVICE_LABEL': 'Perangkat',
  'menu.DEVICE_DISCONNECT': 'Putuskan',
  'menu.FOXIT': 'Didukung oleh Foxit',
  'menu.TERMS_OF_USE': 'Ketentuan penggunaan',
  'menu.SIGN_OUT': 'Keluar',
  'menu.PRINT_PAGE': 'Cetak halaman',
  'menu.COPY_RIGHT': 'Hak Cipta © {year} Pearson Education Inc. Hak Cipta Dilindungi Undang-Undang.',
  'print.FOOTER_MESSAGE': 'Dicetak oleh {fullName}({email}) pada {currentDate}.',
  'print.WATERMARK': 'Hak Cipta © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Anda sudah mengganti bulan ini',
  'device.SWITCH_DEVICE': 'Beralih ke perangkat saat ini?',
  'device.SWITCH_ONCE': 'Karena Anda hanya dapat berganti sekali dalam sebulan, Anda tidak akan dapat mengurungkan ini.',
  'device.SEAT_TAKEN': 'Kursi tersebut sudah terisi',
  'device.DISCONNECT_DEVICE': 'Anda hanya dapat masuk di 3 perangkat. Untuk melanjutkan di sini, putuskan perangkat lainnya.',
  'device.ALERT_TEXT': 'Ingat, Anda hanya dapat berganti perangkat sekali dalam sebulan.',
  'device.DISCONNECT': 'Putuskan',
  'device.CONTINUE': 'Lanjutkan',
  'device.HEADER': 'Akhiri sesi browser yang lain?',
  'device.CLOSE': 'Kembali ke beranda',
  'device.CODE': 'Lanjutkan di sini dengan memasukkan kode autentikasi yang kami kirim ke {maskedEmail}. Tidak berhasil? Periksa folder spam, {email}, atau hubungi {support}.',
  'device.TIMER': 'Anda punya {time} untuk memasukkan kode di sini',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Tanya-Jawab',
  'device.RESEND_NAME': 'Kirim ulang',
  'device.NOTE': 'Jika Anda rutin menggunakan Pearson+ di 2 tempat, seperti di tempat kerja dan di rumah, pastikan untuk keluar setelah selesai. Anda juga dapat menggunakan aplikasi seluler Pearson+ hingga pada 2 perangkat. Untuk info selengkapnya, lihat {faq} kami.',
  'device.NOTE_HEADER': 'Hindari ini lain kali',
  'device.CONTACT_SUPPORT': 'dukungan pelanggan',
  'device.CONTACT_EMAIL': 'perbarui email Anda',
  'device.INCORRECT': 'Salah—periksa kembali kode Anda atau kirim ulang.',
  'device.MANY_ATTEMPTS': 'Terlalu banyak percobaan, coba kirim ulang kode',
  'device.EXPIRED': 'Waktu Anda habis, coba kirim ulang kode',
  'device.ACCESS_HEADER': 'Anda sudah masuk!',
  'device.ACCESS_DESC': 'Sesi Anda telah diautentikasi. Ingin memperbarui kata sandi saat Anda berada di sesi ini?',
  'device.ACCESS_CHANGE_PASSWORD': 'Ubah kata sandi',
  'device.ACCESS_RESET_PASSWORD': 'Atur ulang kata sandi',
  'device.THREATONE_TITLE': 'Semuanya baik-baik saja?',
  'device.THREATONE_DESC': 'Kami memperhatikan beberapa aktivitas mencurigakan di akun Anda.',
  'device.THREATONE_DESC_TWO': 'Ini waktu yang tepat untuk mengubah kata sandi Anda.',
  'device.MAY_BE_LATER': 'Mungkin nanti',
  'device.OKAY': 'Oke',
  'device.ACCOUNT_LOCK_DESC': 'Untuk mengamankannya, kami telah mengeluarkan Anda. Kami telah mengirim tautan pengaturan ulang kata sandi ke email yang terkait dengan akun Anda.',
  'device.ACCOUNT_LOCK_TITLE': 'Kami melihat aktivitas mencurigakan di akun Anda',
  'device.ACCOUNT_LOCK_TIMER': 'Anda akan dikeluarkan dalam {time}',
  'navigation.PAGE': 'Halaman',
  'launchcode.CREATEBY': 'Dibuat oleh:',
  'launchcode.sentvia': 'Dikirim via:',
  'launchcode.CODEINLAST': 'Kode dalam 7 hari terakhir:',
  'launchcode.TIMESENT': 'Waktu dikirim:',
  'launchcode.ACCOUNTEMAIL': 'Email akun:',
  'launchcode.LAUNCHDIALOGTITLE': 'Log Kode OTP',
  'textmessage.TITLE': 'Masukkan Nomor Telepon',
  'textmessage.PHONE_NUMBER': 'Nomor Telepon',
  'textmessage.SEND_CODE': 'Kirim Kode',
  'textmessage.INVALID_NUMBER': 'Nomor Telepon Tidak Valid.',
  'textmessage.SUCCESS_MESSAGE': 'Kode terkirim',
  'remove.title': 'Hapus judul?',
  'remove.subTitle': 'Anda selalu bisa mendapatkannya kembali nanti—cukup gunakan pencarian untuk menambahkannya kembali.',
  'remove.buttonText': 'Hapus',
  'search.searchPlaceHolderPPlus': 'Cari dengan ISBN, Judul, atau Pengarang',
  'search.searchPlaceHolderEText': 'Cari perpustakaan Anda',
  'footer.downloadMobileApp': 'Unduh aplikasi seluler',
  'footer.termsOfUse': 'Ketentuan penggunaan',
  'footer.privacy': 'Privasi',
  'footer.cookies': 'Cookie',
  'footer.doNotSellMyPersonalInformation': 'Jangan jual informasi pribadi saya',
  'footer.accessibility': 'Aksesibilitas',
  'footer.patentNotice': 'Pemberitahuan paten',
  'footer.copyrights': 'Pearson Hak cipta dilindungi undang-undang.',
  'hero.toc.defaultPlacehoder': '--- pilih topik ---',
  'hero.openEtextBookV1': 'Buka Buku eText',
  'hero.heroHeading': 'Karena Anda belajar <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Persiapan Belajar',
  'hero.study.help': 'Dapatkan bantuan belajar',
  'hero.study.jumpBackIn': 'Lanjut kembali',
  'hero.study.numOfUsers': 'Saat ini ada <b>{num_of_users}</b> pelajar yang menggunakan Kanal.',
  'hero.heroChannel.cardsHeading': 'Lanjutkan dari tempat terakhir Anda keluar',
  'hero.marketingcard1.copy.title': 'Belajar dengan video',
  'hero.marketingcard1.copy.description': 'Tonton penjelasan video singkat yang menguraikan topik-topik sulit.',
  'hero.marketingcard2.copy.title': 'Berlatih masalah',
  'hero.marketingcard2.copy.description': 'Persiapkan diri untuk ujian dengan ribuan pertanyaan seperti ujian dan solusi video',
  'hero.marketingcard3.copy.title': 'Dapatkan bantuan berpengalaman',
  'hero.marketingcard3.copy.description': 'Posting pertanyaan dan dapakan jawaban dari pakar bidang studi.',
  'hero.popularTopics.heading': 'Topik populer lainnya di Kanal ini.',
  'hero.popularChannels.headingv1': 'Mengikuti kursus lainnya?',
  'hero.popularChannels.descriptionv2': 'Jejalahi topik bantuan belajar yang populer.',
  'hero.practice': 'Latihan',
  'hero.herobook.mappedChannelHeading': 'Bantuan belajar yang direkomendasikan dalam Kanal ini',
  'libraryL2.myBooks': 'Buku Saya',
  'libraryL2.archived': 'Diarsipkan',
  'libraryL2.back': 'Kembali',
  'hero.practiceProblem': 'Masalah Latihan',
  'nativeAppBanner.drawer.title': 'Buka di ...',
  'nativeAppBanner.drawer.pearsonApp': 'Aplikasi Pearson+',
  'nativeAppBanner.banner.title': 'Aplikasi Pearson+',
  'nativeAppBanner.banner.description': 'Belajar di mana saja',
  'hero.promotionalcard.list1': 'Video singkat yang menguraikan topik-topik sulit',
  'hero.promotionalcard.list2': 'Ribuan soal seperti ujian',
  'hero.promotionalcard.list3': 'Dapakan jawaban dari pakar bidang studi',
  'hero.studyandexamprep': 'Persiapan Belajar',
  'hero.heroBook.sectionSubHeadingV1': 'Pecahkan topik sulit dengan penjelasan video dan soal latihan yang disesuaikan dengan mata pelajaran Anda.',
  'hero.heroBook.sectionSubHeadingV2': 'Pecahkan topik sulit dengan penjelasan konsep dan soal latihan yang disesuaikan dengan mata pelajaran Anda.',
  'hero.SeeAllStudyOptions': 'Lihat semua opsi belajar',
  'hero.herobook.mappedChannelHeadingV1': 'Video dan soal latihan yang direkomendasikan',
  'hero.popularTopics.headingV1': 'Topik populer lainnya',
  'hero.heroHeadingV1': 'Untuk <span>{replace_value}</span>',
  'hero.learnmore': 'Pelajari selengkapnya',
  'hero.eTextbook': 'Buku eText',
  'hero.goToPage.label': 'Buka halaman',
  'subscription.studyTitle': 'Persiapan Belajar',
  'print.printAvailTitle': 'Ingin mencetak halaman ini? Berikut ini caranya',
  'print.printAvailDesc': 'Di buku eText Anda, pilih ikon akun dari kanan atas. Dari opsi, pilih "Cetak halaman" lalu pilih pengaturan cetak Anda.',
  'print.printNotAvailTitle': 'Opsi pencetakan untuk eText ini tidak diaktifkan.',
  'print.printNotAvailDesc': 'Untuk akses offline yang nyaman, silakan unduh judul melalui aplikasi seluler Pearson+ dan nikmati fleksibilitas belajar kapan saja, di mana saja!',
  'hero.header.cta': 'Kunjungi sarana belajar',
  'hero.header.ctav2': 'Buka Persiapan Belajar',
  'hero.marketing.title': 'Temukan Buku eText Anda',
  'hero.marketing.subTitle': 'Pilih lebih dari 2.000 buku eText dengan audio, flashcard, catatan, dan lainnya. Hanya $10,99/bln untuk 4 bulan.',
  'hero.popularchannels.desc': 'Dapatkan bantuan belajar dengan bidang studi teratas ini.',
  'hero.removecourse.title': 'Hapus kursus dari Dasbor?',
  'hero.removecourse.description': 'Anda selalu dapat menambahkan mata pelajaran ini kembali ke dasbor dengan mengeklik "Tambahkan kursus"',
  'hero.removecourse.primaryCtaText': 'Hapus',
  'hero.removecourse.secondaryCtaText': 'Batal',
  'hero.tableOfContents': 'Daftar Isi',
  'hero.search': 'Cari',
  'hero.emptystate.cta': 'Cari buku eText',
  'hero.watch_it_again': 'Tonton lagi',
  'hero.mondly.learnLang.title': 'Belajar bahasa baru secara gratis',
  'hero.mondly.subTitle': 'Pengguna Buku eText Pearson mendapatkan tiga bulan gratis Mondly by Pearson.',
  'hero.mondly.description': 'Sebagian besar aplikasi belajar bahasa hanya memungkinkan Anda belajar dari bahasa Inggris. Tetapi paling optimal adalah belajar dari bahasa ibu, sehingga Mondly memungkinkan Anda belajar dari salah satu dari <strong>41 bahasa</strong> kami.',
  'hero.mondly.startLearningCTA': 'Mulai belajar',
  'hero.mondly.marketing.bestApp': 'Aplikasi Terbaik',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Aplikasi Terbaik Tahun ini',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - Pemenang EMEA 2017',
  'hero.mondly.marketing.editorChoice': 'Pilihan Editor',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Belajar bahasa',
  'header.menu.moreAtPearson': 'Selengkapnya di Pearson',
  'hero.subscriptionStatusTitle2': 'Sumber Daya Pearson+ Anda',
  'hero.startStudying': 'Mulai belajar',
  'onboard.studyMaterials': 'Pilih mata pelajaran Anda dan kami akan membuat dasbor dengan materi belajar khusus.',
  'hero.myETextbooks': 'Buku eText saya',
  'header.continueInTheApp': 'Lanjutkan di aplikasi',
  'hero.learnTxt': 'Pelajari',
  'hero.examPrepTxt': 'Persiapan ujian',
  'hero.aITutorTxt': 'Tutor AI',
  'AI.toolTip': 'Tanya saya tentang apa saja di buku eText Anda',
  'hero.studyExamPrepAllYourCourses': 'Persiapan belajar untuk semua mata pelajaran',
  'header.qrCode.subHeaderTxt': 'Gunakan kode QR ini untuk masuk dengan cepat dan aman ke aplikasi Pearson+ di perangkat seluler.',
  'header.qrCode.dontHaveApp': 'Tidak punya aplikasinya?',
  'header.qrCode.footerTxt': 'Memindai kode ini akan mengarahkan Anda ke App Store atau Google Play. Setelah aplikasi diunduh, masuk dengan memindainya lagi.',
  'header.qrCode.errorMsg': 'Kode QR tidak dimuat. Tutup dan coba lagi.',
  'hero.yourETextbook': 'Buku eText Anda',
  'onboard.addCourseWithEtextBundle': 'Tambahkan mata pelajaran menggunakan Persiapan Belajar',
  'onboard.disableTooltipText': 'Semua mata pelajaran Persiapan Belajar ditambahkan!',
  'subscriptionstatus.bundlecta': 'Akses Persiapan Belajar',
  'subscriptionstatus.nonbundlecta': 'Akses Persiapan Belajar',
  'channel.genericBundle': 'Gunakan Persiapan belajar untuk membantu dalam mata pelajaran lain',
  'channel.relatedBundle': 'Juga gunakan Persiapan Belajar untuk membantu dalam mata pelajaran lain',
  'onboard.courseAdded': 'Kursus ditambahkan!',
  'hero.flashcards': 'Flashcard',
  'relatedChannelCard.title': 'Tingkatkan belajar Anda dengan sumber daya terkait ini',
  'relatedChannelCard.badgeText': 'Persiapan Belajar Terkait',
  'sessionInactivity.title': 'Anda masih ada di situ?',
  'sessionInactivity.description': 'Sesi Anda akan kehabisan waktu dalam <b>%TIMER%</b> karena tidak ada aktivitas.<br/> Apakah Anda ingin tetap masuk?',
  'sessionInactivity.keepMeSignIn': 'Biarkan saya tetap masuk',
  'sessionInactivity.signOut': 'Keluar',
  'sessionTimeout.title': 'Sesi kehabisan waktu',
  'sessionTimeout.description': 'Sesi Anda telah kehabisan waktu karena tidak ada aktivitas.',
  'print.qrCode.header': 'Gunakan kode QR ini untuk membuka aplikasi Pearson+ di perangkat seluler.',
  'print.qrCode.footer': 'Memindai kode ini akan mengarahkan Anda ke App Store atau Google Play. Setelah aplikasi diinstal, masuk dengan mengunduh dan mengakses judul Anda.',
  'hero.nestest.title': 'Persiapkan diri untuk ujian sertifikasi guru',
  'hero.nestest.subTitle': 'Pengguna Pearson+ sekarang dapat mengakses kursus persiapan dan tes latihan yang disesuaikan secara nasional untuk mempersiapkan ujian sertifikasi guru.',
  'hero.channelAI.title': 'Perlu bantuan? Tutor AI akan membantu Anda.',
  'hero.channelAI.desc': 'Ajukan pertanyaan dan dapatkan bantuan penyelesaian PR langkah demi langkah, rekomendasi belajar, dan lainnya—bantuan personal kapan pun Anda membutuhkannya.',
  'hero.channelAI.action': 'Tanya Tutor AI Sekarang',
  'new': 'Baru!',
  'hero.practice.numOfUsers': 'Bagian ini memiliki <b>{practice_num_of_users}</b> masalah latihan.',
  'hero.practice.cta': 'Berlatih sekarang',
  'hero.practice.title': 'Masalah latihan',
  'diagnostics.errorMsg': 'Diagnostik tidak dimuat. Tutup dan coba lagi.',
  'qrcode.title': 'Mulai belajar di mana saja',
  'qrcode.subtitle': 'Belajar di mana saja, kapan saja dengan aplikasi seluler Pearson+. Unduh sekarang dan buka pengalaman belajar yang lancar.',
  'qrcode.detailsv1': 'Dengan aplikasi Pearson+, Anda dapat menggunakan kode QR untuk melanjutkan di titik terakhir yang Anda tinggalkan. Cari buku, belajar dengan flashcard, tonton pelajaran video, dan lainnya ke mana pun Anda pergi.',
  'qrcode.detailsv2': 'Pindai kode QR ini di mana pun Anda ingin masuk dengan cepat dan lanjutkan di titik terakhir yang Anda tinggalkan.',
  'qrcode.details': 'Dengan aplikasi Pearson+, Anda dapat menggunakan kode QR untuk melanjutkan di titik terakhir yang Anda tinggalkan.',
  'qrcode.appstore': 'di App Store',
  'qrcode.playstore': 'di Google Play',
  'nativePromoBanner.description': 'Belajar di mana saja, kapan saja dengan aplikasi seluler Pearson+. Unduh sekarang dan buka pengalaman belajar yang lancar.',
  'install': 'Install',
  'header.menu.createCourse': 'Kursus baru',
  'header.dropdown.courses': 'Kursus',
  'header.dropdown.recentlyViewed': 'Baru saja dilihat',
  'header.dropdown.viewAll': 'Lihat semua kursus',
  'aet.courseHeader.inviteStudents': 'Undang pelajar',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Undang pelajar untuk mengakses buku eText ini dengan menyalin alamat tautan atau instruksi di bawah ini ke dalam email atau silabus Anda.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Alamat tautan',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Salin tautan',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instruksi dengan alamat tautan',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Salin instruksi',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Saatnya mengakses {bookTitle} buku eText untuk {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Saat Anda siap, akses Buku eText Anda di: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Anda akan diminta untuk masuk dengan akun Pearson yang sudah ada, Jika Anda tidak memiliki akun Pearson, Anda akan dapat membuat akun.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Perlu Bantuan?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Tanggal mulai:',
  'aet.courseHeader.endDate': 'Tanggal berakhir:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Kelola daftar pelajar',
  'aet.home.managegradesync': 'Kelola sinkronisasi kelas',
  'aet.home.copycourse': 'Salin kursus',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Saat ini',
  'aet.instructorCourse.tabs.past': 'Yang Lalu',
  'aet.instructorCourse.tabs.courseSettings': 'Pengaturan kursus',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Kelola daftar pelajar',
  'aet.instructorCourse.currentCourses.title': 'Kursus saat ini',
  'aet.instructorCourse.pastCourses.title': 'Kursus yang lalu',
  'aet.instructorCourse.createOrCopy.title': 'Buat atau salin kursus buku eText Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Salin kursus instruktur lain atau buat kursus baru',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Salin kursus instruktur lain',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Masukkan ID kursus untuk menemukan kursus yang ingin Anda salin',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID Kursus',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Masukkan ID kursus',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Anda mencari',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Buat kursus baru dari katalog',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Cari dengan judul, pengarang, ISBN, atau kata kunci bidang studi',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Cari...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Tampilkan selengkapnya',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Tampilkan lebih sedikit',
  'aet.instructorCourse.cancel': 'Batal',
  'aet.instructorCourse.loading': 'Memuat...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sinkronisasi kelas',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Kelola sinkronisasi kelas',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nama kursus',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Tanpa Judul',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nama bagian',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Tanpa Judul',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institusi',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institusi diperlukan',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Terjadi kesalahan. Silakan coba lagi.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Tidak ditemukan hasil',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Tanggal mulai kursus',
  'aet.instructorCourse.courseForm.endDateLabel': 'Tanggal berakhir kursus',
  'aet.instructorCourse.courseForm.datePlaceholder': 'hh/bb/tt',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Izinkan orang lain menyalin kursus ini',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Bagikan kode ini kepada instruktor yang ingin menyalin kursus ini',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Salin kode',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opsional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Formulir memiliki kesalahan validasi',
  'aet.instructorCourse.courseForm.submitContinue': 'Lanjutkan',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Menyimpan...',
  'aet.instructorCourse.courseForm.submitError': 'Kami tidak dapat membuat kursus Anda. Silakan coba lagi.',
  'aet.instructorCourse.courseForm.submitEditError': 'Kami tidak dapat menyimpan perubahan Anda. Silakan coba lagi.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Simpan perubahan',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materi kursus',
  'aet.instructorCourse.courseForm.resolveError': 'Kami tidak dapat memuat materi kursus. Silakan coba lagi.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Terakhir dilihat',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Baru saja ditambahkan',
  'aet.instructorCourse.coursesSort.aToZ': 'A ke Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z ke A',
  'aet.instructorCourse.manageRoster.column.name': 'Nama',
  'aet.instructorCourse.manageRoster.column.role': 'Peran',
  'aet.instructorCourse.manageRoster.column.email': 'Email',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Mendaftar {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Siswa',
  'aet.instructorCourse.roster.role.ta': 'Asisten Pengajar',
  'aet.instructorCourse.roster.role.instructor': 'Instruktur',
  'aet.instructorCourse.roster.status.active': 'Aktif',
  'aet.instructorCourse.roster.status.inactive': 'Nonaktif',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Semua anggota',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Pelajar aktif',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Pelajar tidak aktif',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Asisten Pengajar',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instruktur',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Pengarang:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Tanggal pembuatan kursus:',
  'aet.instructorCourse.noCoursesFound': 'Kursus tidak ditemukan',
  'aet.instructorCourse.backButton': 'Kembali',
  'aet.instructorCourse.selectCourse': 'Pilih kursus',
  'aet.home.linkedToLms': 'Ditautkan ke LMS',
  'aet.instructorCourse.courseForm.title.create': 'Buat kursus',
  'aet.instructorCourse.courseForm.title.copy': 'Salin kursus',
  'aet.instructorCourse.courseForm.title.edit': 'Informasi kursus',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Tugas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Konten tugas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Tanggal batas waktu tugas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Sorotan dan catatan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Warna sorotan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Teks catatan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Status bersama',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Daftar pelajar dan keterlibatan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nama pelajar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Alamat email',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Pendaftaran',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Penyelesaian dan wawasan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Pengaturan',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Data yang disalin',
  'aet.studentRoster.manageStudentRosterButton': 'Kelola daftar pelajar',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Ekspor kemajuan pelajar',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Terdaftar:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Peran:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promosikan {studentName}?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Sebagai asisten pengajar, orang ini akan dapat melihat perkembangan dan kinerja semua pelajar di kelas ini.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Mereka juga akan dapat mengelola pelajar dan tugas, namun mereka tidak akan dapat menghapus kelasnya.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promosikan menjadi asisten pengajar',
  'aet.home.manageRoster.searchPlaceholder': 'Cari pelajar',
  'aet.home.manageRoster.inactivateButtonLabel': 'Pelajar terpilih tidak aktif',
  'aet.home.manageRoster.FilterLabel': 'Tampilkan',
  'aet.home.manageRoster.updatingMessage': 'Memperbarui daftar... Ini mungkin memerlukan beberapa menit.',
  'aet.home.courses.search.searchPlaceHolder': 'Cari kursus Anda',
  'aet.courses.emptyStateDescription': 'Mulai menyusun kursus Anda dengan memilih opsi di bawah ini.',
  'nativePromoBanner.continueInBrowser': 'Lanjutkan di browser',
  'globalnav.tooltip.hideNavText': 'Sembunyikan navigasi',
  'globalnav.tooltip.showNavText': 'Tampilkan navigasi',
  'aet.syllabus.progressTitle': 'Mengekstrak...',
  'aet.syllabus.progressDesc': 'Harap tunggu saat kami memroses silabus Anda.',
  'aet.syllabus.uploadInputLabel': 'Seret dan letakkan file atau klik untuk mengunggah',
  'aet.syllabus.uploadSyllabusTabLabel': 'Unggah silabus',
  'aet.syllabus.dateAdjusterTabLabel': 'Pengatur tanggal',
  'aet.syllabus.addManuallyTabLabel': 'Tambahkan tugas secara manual',
  'aet.syllabus.addEditLaterText': 'Anda selalu dapat menambahkan dan mengedit tugas nanti.',
  'aet.syllabus.editAssignmentLabel': 'Edit tugas',
  'aet.syllabus.addAssignmentLabel': 'Tambahkan tugas',
  'aet.syllabus.assignmentTitleLabel': 'Judul Tugas',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Tanggal batas waktu',
  'aet.syllabus.editDueDateLabel': 'Edit tanggal batas waktu',
  'aet.syllabus.chaptersCoveredLabel': 'Pilih bab atau bagian untuk dibahas.',
  'aet.syllabus.updateCtaLabel': 'Perbarui tugas',
  'aet.syllabus.addCtaLabel': 'Tambahkan tugas',
  'aet.syllabus.uploadLabel': 'Unggah',
  'aet.syllabus.confirmLabel': 'Konfirmasi',
  'aet.syllabus.addContentLabel': 'Tambahkan konten',
  'aet.syllabus.addEditContentLabel': 'Tambah/edit konten',
  'aet.syllabus.notPublishedLabel': 'Tidak dipublikasikan',
  'aet.syllabus.updateDatesLabel': 'Perbarui tanggal',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Tanggal batas waktu Anda diperbarui. Tinjaulah, lalu publikasikan.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Informasi bab/bagian Anda diperbarui. Tinjaulah, lalu publikasikan.',
  'aet.syllabus.unassignedCoverageStatus': 'Beberapa bab belum ditugaskan. Tugaskan bab tersebut sebelum Anda publikasikan.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Hapus tugas?',
  'aet.deleteAssignmentTitleMultiple': 'Hapus tugas?',
  'aet.deleteAssignmentWarning': 'Tindakan ini tidak dapat dibatalkan, dan semua pengiriman terkait dan data pelajar sudah tidak akan terlihat.',
  'aet.deleteAssignmentKeepCTA': 'Simpan tugas',
  'aet.deleteAssignmentDeleteCTA': 'Hapus',
  'aet.assignments.loadingAsset': 'Memuat aset...',
  'aet.assignments.addToDate': 'Tambahkan ke tanggal',
  'aet.assignments.previewAsStudent': 'Lihat pratinjau sebagai pelajar',
  'aet.assignments.questionsAndTopics': 'Pertanyaan dan topik',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Selesai',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Tanggal batas waktu',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Total pertanyaan',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Pertanyaan {count} dari {total}',
  'aet.assignments.publishToStudents': 'Publikasikan ke pelajar',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Tambahkan tanggal',
  'aet.doneLabel': 'Selesai',
  'aet.assignments.dueDateLabel': 'Tanggal batas waktu tugas',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Pengaturan manual',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Gunakan wawasan real-time untuk mengetahui kesenjangan belajar, sehingga Anda dapat bertindak lebih awal dengan percaya diri',
  'aet.onboarding.promotion.feature.3': 'Pelajar menerima lebih banyak dukungan dengan masukan tersasar dan AI Pearson bawaan',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'Tidak ada tugas dengan tenggat minggu ini.',
  'aet.assignments.progressTitle': 'Kemajuan',
  'aet.assignments.performanceTitle': 'Kepercayaan Diri',
  'aet.assignments.completionTitle': 'Penyelesaian',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Tambahkan tugas',
  'aet.assignments.deleteTooltip': 'Hapus tugas terpilih',
  'aet.assignments.selectToDeleteLabel': 'Pilih dan hapus mode',
  'aet.assignments.bulkEditTooltip': 'Edit tugas secara massal',
  'aet.assignments.title': 'Tugas',
  'aet.assignments.assignmentTitle': 'Tugas',
  'aet.assignments.dueDate': 'Tanggal batas waktu',
  'aet.tabular.searchPlaceholder.assignments': 'Cari tugas',
  'aet.tabular.searchPlaceholder.students': 'Cari pelajar',
  'aet.tabular.searchPlaceholder.questions': 'Cari pertanyaan',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Satu atau beberapa pelajar memiliki perpanjangan batas waktu untuk semua tugas',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Satu atau beberapa pelajar memiliki perpanjangan batas waktu untuk tugas ini',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Satu atau beberapa pelajar diberi perpanjangan batas waktu. Cari ikon Info untuk mengetahui tugas ini.',
  'aet.home.loading': 'Memuat...',
  'aet.home.errorFetchingAssignments': 'Kesalahan mengambil tugas',
  'aet.home.dueThisWeekTitle': 'Tenggal minggu ini',
  'aet.home.allCaughtUpTitle': 'Semua sudah Anda lihat!',
  'aet.home.allCaughtUpDescription': 'Tidak ada tugas dengan tenggat minggu ini.',
  'aet.home.suggestedRemediationTitle': 'Ulasan yang disarankan oleh Persiapan Belajar',
  'aet.home.noSuggestedRemediationTitle': 'Tidak ada saran materi peninjauan',
  'aet.home.noSuggestedRemediationDescription': 'Periksa kembali setelah tugas Anda berikutnya.',
  'aet.home.assignmentIncludesTitle': 'Tugas meliputi',
  'aet.home.sectionsLabel': 'Bab',
  'aet.home.questionsCount': '{count} pertanyaan',
  'aet.home.dueLabel': 'Tenggat: {dueDate}',
  'aet.home.due': 'Tenggat:',
  'aet.home.progressCompletedLabel': 'Selesai',
  'aet.home.progressCompletedPastDueLabel': 'Selesai dengan tenggat terlewat',
  'aet.home.progressInProgressLabel': 'Sedang berlangsung',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Belum dimulai',
  'aet.home.progressCountOfTotal': '{count} dari {total}',
  'aet.home.NotAttemptedLabel': 'Tidak berusaha',
  'aet.home.questionsTotalLabel': 'Total pertanyaan',
  'aet.home.progressCompletedOnTimeLabel': 'Selesai tepat waktu',
  'aet.home.segmentGreatLabel': 'Bagus',
  'aet.home.segmentGettingThereLabel': 'Oke',
  'aet.home.segmentNeedsReviewLabel': 'Perlu ditingkatkan',
  'aet.home.segmentOkayLabel': 'Oke',
  'aet.home.editAssignmentTooltip': 'Edit tugas',
  'aet.home.deleteAssignmentTooltip': 'Hapus tugas',
  'aet.home.viewDetailsButton': 'Lihat rincian',
  'aet.home.viewAsStudentButton': 'Lihat sebagai pelajar',
  'aet.home.welcomeButtonText': 'Mulai →',
  'aet.review.emptyStateTitle': 'Tidak ada yang perlu ditinjau',
  'aet.review.emptyStateDescription': 'Periksa kembali setelah tugas Anda berikutnya.',
  'aet.dashboard.tabs.upNext': 'Akan datang',
  'aet.dashboard.tabs.welcome': 'Selamat Datang',
  'aet.dashboard.tabs.assignments': 'Tugas',
  'aet.dashboard.tabs.review': 'Tinjau',
  'aet.dashboard.tabs.studentRoster': 'Pelajar',
  'aet.dashboard.classSchedule': 'Jadwal kelas:',
  'aet.syllabus.dueTimeLabel': 'Batas waktu',
  'hero.accessEducatorGuides': 'Akses panduan pendidik',
  'aet.assignment.save': 'Simpan',
  'aet.assignment.finish': 'Selesaikan',
  'aet.assignment.saveAndAdd': 'Simpan dan tambahkan lainnya',
  'aet.assignment.delete': 'Hapus',
  'aet.assignment.saveAndClose': 'Simpan dan tutup',
  'aet.studentRoster.title': 'Pelajar',
  'aet.studentRoster.titlev1': 'Siswa',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Tanggal batas waktu',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standar',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 hari',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 hari',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 hari',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 minggu',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 minggu',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Hari terakhir kelas',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} tugas diperbarui',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Tugas lewat batas waktu tidak dapat diperbarui secara otomatis. Edit setiap tugas untuk menetapkan tanggal batas waktu baru.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Tidak dapat memperbarui tanggal batas waktu',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Semua tugas sudah lewat batas waktu dan tidak dapat diperbarui secara otomatis. Edit setiap tugas untuk menetapkan tanggal tenggat baru.',
  'aet.bulkEdit.bulkSplitInstruction': 'Kami akan membagi tugas Anda secara merata.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Tenggat tugas pertama',
  'aet.bulkEdit.lastAssignmentDue': 'Tenggat tugas kedua',
  'aet.bulkEdit.assignmentsDueDays': 'Hari apa Anda ingin menetapkan tenggat tugas?',
  'aet.bulkEdit.addEditLaterText': 'Kami menggunakan AI untuk membuat tugas. Anda selalu dapat menambahkan dan mengedit tugas nanti.',
  'aet.bulkEdit.monday': 'Senin',
  'aet.bulkEdit.tuesday': 'Selasa',
  'aet.bulkEdit.wednesday': 'Rabu',
  'aet.bulkEdit.thursday': 'Kamis',
  'aet.bulkEdit.friday': 'Jumat',
  'aet.bulkEdit.saturday': 'Sabtu',
  'aet.bulkEdit.sunday': 'Minggu',
  'aet.toast.assignmentCreated.title': 'Tugas dibuat!',
  'aet.toast.assignmentCreated.single': 'Otomatis sudah diberi nama {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} tugas telah dibuat',
  'aet.toast.assignmentUpdated.title': 'Berhasil diperbarui.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} telah diperbarui',
  'aet.toast.assignmentUpdated.multiple': '{count} tugas telah diperbarui',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'Konten tugas dapat diedit hingga pelajar mulai mengerjakannya.',
  'aet.toast.viewAssignment': 'Lihat tugas',
  'aet.toast.viewAssignments': 'Lihat tugas',
  'aet.welcome.title': 'Buku eText Pearson Anda sekarang terhubung ke mata pelajaran LMS',
  'aet.welcome.LMSAccounTitle': 'Jelajahi wawasan',
  'aet.welcome.LMSAccounDescription': 'Lihat topik mana yang sulit dipahami kelas Anda.',
  'aet.welcome.createAssignmentsTitle': 'Buat tugas',
  'aet.welcome.createAssignmentsDescription': 'Tugaskan bab secara manual atau dengan mengunggah silabus.',
  'aet.welcome.progressViewTitle': 'Lacak kinerja di LMS',
  'aet.welcome.progressViewDescription': 'Pilih pengaturan sinkronisasi nilai di mata pelajaran LMS Anda.',
  'aet.assignmentDetails.noAssignmentFound': 'Tugas tidak ditemukan',
  'aet.assignments.loadingErrorTitle': 'Tugas tidak dapat dimuat saat ini',
  'aet.assignments.loadingErrorDescription': 'Coga segarkan atau periksa kembali nanti.',
  'aet.assignmentStudentDetails.noDataFound': 'Belum ada data',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Tidak ada pelajar yang mendaftar',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Pelajar akan bergabung dengan kelas Anda saat mereka membeli Buku eText.',
  'aet.home.editAssignmentTooltipDisabled': 'Tidak bisa mengedit: sedang dikerjakan siswa',
  'aet.home.deleteAssignmentTooltipDisabled': 'Tidak bisa menghapus: sedang dikerjakan siswa',
  'aet.home.StudentDetails.questions': 'Pertanyaan',
  'aet.home.StudentDetails.attempts': 'Percobaan',
  'aet.home.StudentDetails.comprehension': 'Kepercayaan Diri',
  'hero.titleInfo.tooltip': 'Informasi judul',
  'aet.home.publishAssignments': 'Publikasikan semua tugas',
  'aet.assignments.saveScheduleAsDraft': 'Simpan jadwal sebagai draf',
  'aet.assignments.reviewBeforePublishAlert': 'Tinjau tugas Anda, kemudian publikasikan agar dapat dilihat oleh pelajar.',
  'aet.assignments.copiedCoursePublishAlert': 'Tambahkan tanggal ke tugas yang Anda salin, dan publikasikan agar dapat dilihat oleh pelajar.',
  'aet.assignments.allSetPublishAlert': 'Semua beres? Publikasikan tugas Anda agar dapat dilihat oleh pelajar.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Beberapa konten dibuat menggunakan AI berdasarkan materi belajar Pearson. Meskipun Pearson memiliki proses untuk memvalidasi outputnya, AI generatif mungkin masih menghasilkan informasi yang tidak akurat tentang orang, tempat, atau fakta.',
  'aet.home.bulkEditTitle': 'Edit tugas secara massal',
  'aet.home.bulkEditSubtitle': 'Lakukan perubahan pada silabus Anda, lalu unggah ulang di sini. Tugas dan tanggal batas waktu',
  'aet.home.createAssignmentTitle': 'Buat tugas',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Disertakan di tugas lain',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Beberapa bagian disertakan di tugas lain',
  'aet.welcome.welcome.Title': 'Selamat Datang!',
  'aet.home.student.roaster.ProgressTitle': 'Total penyelesaian',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Periksa kembali setelah pelajar memulai tugas.',
  'aet.home.whatDueThisWeekTitle': 'Berikut dengan tenggat minggu ini',
  'aet.assignments.edit.errorTitle': '{count} tugas memiliki kesalahan',
  'aet.assignments.edit.errorSubTitle': 'Tugas dengan kesalahan tidak dapat dipublikasikan. Edit kesalahan atau publikasikan tanpa kesalahan.',
  'aet.assignments.edit.publishAnyway': 'Tetap publikasikan',
  'aet.assignments.edit.editAssignments': 'Edit tugas',
  'aet.assignments.edit.validationInfoToolTip': 'Edit tugas untuk menghapus kesalahan',
  'aet.assignments.error.assignmentCreated.title': 'Semua tugas memiliki kesalahan',
  'aet.assignments.error.assignmentCreated.description': 'Tugas dengan kesalahan tidak dapat dipublikasikan. Edit kesalahan atau coba silabus berbeda.',
  'aet.assignments.error.uploadSyllabus': 'Unggah silabus',
  'aet.assignments.error.editAssignments': 'Edit tugas',
  'aet.mondly.title': 'Bahasa',
  'aet.studentRoster.errorState.title': 'Daftar siswa tidak tersedia',
  'aet.studentRoster.errorState.description': 'Kami tidak dapat memuat daftar siswa Anda. Coba segarkan atau periksa kembali nanti.',
  'aet.assignments.sectionLabel': 'bagian',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'pertanyaan',
  'aet.assignments.assignmentsLabel': 'tugas',
  'aet.assignments.performanceProgressBar': 'Bilah Kemajuan Kinerja',
  'aet.assignments.completionProgressBar': 'Bilah Kemajuan Penyelesaian',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Anda yakin ingin menghapus tugas ini?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Anda yakin ingin menghapus tugas-tugas ini?',
  'aet.home.nextAssignmentTitle': 'Tugas Berikutnya',
  'aet.home.courseSettings': 'Pengaturan kursus',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Sumber daya Buku eText Pearson+',
  'aet.home.etextbookInformation': 'informasi buku eText',
  'aet.multiple.deleteAssignmentKeepCTA': 'Simpan tugas',
  'aet.syllabus.processingText.header': 'Kami sedang mengelola tugas membaca kelas Anda – ini hanya perlu waktu sebentar.',
  'aet.syllabus.processingText.uploading': 'Mengunggah dokumen Anda',
  'aet.syllabus.processingText.activating': 'Mengaktifkan komponen AI',
  'aet.syllabus.processingText.extracting': 'Mengekstrak tugas membaca',
  'aet.syllabus.processingText.mapping': 'Memetakan ke konten buku teks',
  'aet.syllabus.processingText.finishing': 'Menyelesaikan',
  'aet.syllabus.uploadErrorMessage': 'Pastikan PDF atau .docx kurang dari 10MB dan pastikan koneksi internet Anda stabil',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Tugas membaca tidak ditemukan',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Kami tidak dapat mengambil tugas membaca dari file ini. Anda dapat menambahkannya secara manual.',
  'aet.syllabus.uploadFailedRetryCTA': 'Coba lagi',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Periksa ulang untuk melihat bahwa silabus Anda memiliki <qualities a syllabus should have for this to work> dan coba lagi, atau pindah ke pembuatan tugas manual.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Pembuatan manual',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Terjadi kesalahan',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Kami tidak dapat mengunggah dan memproses silabus.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Periksa koneksi dan coba lagi, atau pindah ke pembuatan tugas manual.',
  'aet.syllabus.uploadModal.successTotal.title': 'Siap ditinjau',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Siap ditinjau',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Tinjau tugas',
  'aet.syllabus.selectChapterWithQuestions': 'Pilih bab dengan pertanyaan.',
  'preferenceSetting.subTitle': 'Pengaturan ini akan menjadi default untuk semua pelajar dalam kursus ini.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interaksi AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Aktifkan Alat Belajar AI dan ringkasan AI dalam hasil pencarian',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Tampilkan sumber daya Persiapan Belajar yang terkait dengan buku ini',
  'aet.syllabus.footer': 'Pembuatan tugas didukung oleh AI',
  'aet.dashboard.footerDialogDeatils': 'AI Generatif digunakan untuk membuat soal tugas berdasarkan materi belajar Pearson. Meskipun Pearson memiliki proses untuk memvalidasi outputnya, AI generatif mungkin masih menghasilkan informasi yang tidak akurat tentang orang, tempat, atau fakta. AI juga digunakan untuk mengelompokkan konten menjadi beberapa tugas, berdasarkan silabus dan/atau jadwal yang Anda berikan.',
  'aet.review.footer': 'Dibuat menggunakan AI',
  'aet.footerCard.dismiss': 'Tutup',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Persiapan Belajar merupakan sarana tambahan yang mendukung belajar dengan membekali siswa dengan video dan masalah latihan yang disesuaikan dengan mata pelajaran ini.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Pelajar yang paket aksesnya tidak termasuk Persiapan Belajar dapat diminta untuk berlangganan agar dapat terus menggunakan sumber daya Persiapan Belajar.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Pelajar yang telah membeli Persiapan Belajar tidak akan terpengaruh dengan pengaturan ini.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Pelajari selengkapnya tentang manfaat Persiapan Belajar',
  'aet.home.viewCourseId': 'Lihat ID mata pelajaran',
  'aet.home.copy': 'Salin',
  'aet.home.copied': 'Disalin',
  'aet.home.courseLabel': 'ID Mata Pelajaran:',
  'schoolInfoCard.addUniversity': 'Tambahkan sekolah',
  'schoolInfoCard.title': 'Informasi sekolah',
  'schoolInfoCard.titleV1': 'Beri tahu kami tentang kursus Anda',
  'schoolInfoCard.cta': 'Mulai',
  'schoolInfoCard.pickInstitution': 'Pilih sekolah',
  'schoolInfoCard.addUniversityTitle': 'Tambahkan sekolah Anda',
  'schoolInfoCard.addUniversitySubtitle': 'Mengetahui sekolah dan mata pelajara Anda memungkinkan kami merekomendasikan materi belajar yang paling bermanfaat.',
  'schoolInfoCard.searchPlaceholder': 'Cari sekolah Anda...',
  'schoolInfoCard.skip': 'Lewati langkah ini',
  'schoolInfoCard.nextStep': 'Langkah berikutnya',
  'schoolInfoCard.notInList': 'Sekolah saya tidak ada dalam daftar',
  'schoolInfoCard.noResults': 'Tidak ada sekolah yang cocok dengan pencarian Anda',
  'schoolInfoCard.noResultsHeading': 'Tidak dapat menemukan sekolah Anda?',
  'schoolInfoCard.noResultsInstruction': 'Masukkan nama lengkap di bawah ini',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nama sekolah',
  'schoolInfoCard.addInstitutionLabel': 'Tambahkan sekolah ini',
  'aet.assignments.assignmentTitlePlaceholder': 'Masukkan judul',
  'aet.assignments.titleValidation.titleRequired': 'Judul tugas ini wajib diisi.',
  'aet.assignments.titleValidation.titleTooLong': 'Judul tugas tidak boleh lebih dari {0} karakter.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Judul tugas mengandung karakter yang tidak didukung.',
  'aet.assignments.titleValidation.titleDuplicate': 'Judul tugas sudah ada',
  'aet.syllabus.timeZoneLabel': 'Zona waktu',
  'aet.review.reviewReadingFromAssignments': 'Tinjau bacaan dari tugas',
  'aet.assignments.chaptersLabel': 'bab',
  'menu.myAccount.subTitle': 'Institusi Anda ada di sini',
  'menu.myAccount.subTitleNotAvailable': 'Anda dapat menambahkan institusi di sini nanti kapan saja.',
  'schoolInfoCard.toastMessage': 'Universitas disimpan',
  'aet.review.threeDotMenu.askAI': 'Tanya AI',
  'aet.home.suggestedRemediationSubtitle': 'Tonton video terkait dan berlatihlah untuk menguasai topik kursus Anda.',
  'aet.home.laggedQuestionLabel': 'Pertanyaan ditandai',
  'aet.home.correctAnswer': 'Jawaban benar',
  'aet.home.incorrectAnswer': 'Jawaban salah paling umum',
  'aet.home.behaviourTrendsLabel': 'Wawasan pertanyaan',
  'aet.home.strugglingStudentsLabel': 'Pelajar yang kesulitan',
  'aet.home.patternsInStudensAiLabel': 'Pola dalam penggunaan AI pelajar',
  'aet.home.questionLabel': 'Pertanyaan',
  'aet.home.studentAskingSimilarQuestions': 'Pelajar mengajukan pertanyaan serupa',
  'aet.home.assignmentDifficultQuestions': 'Pertanyaan sulit',
  'aet.home.behaviorTrends': 'Wawasan pertanyaan',
  'aet.home.behaviors': 'Indikator kinerja',
  'aet.home.mostDifficultTopics': 'Pertanyaan paling sulit',
  'aet.home.commentsFromStudentLabel': 'Komentar dari pelajar',
  'aet.home.disregard': 'Abaikan',
  'aet.home.reportAsInaccurate': 'Laporkan tidak akurat',
  'aet.home.Flagged': 'Ditandai',
  'aet.home.reportQuestionTitle': 'Laporkan pertanyaan',
  'aet.home.reportQuestionLabel': 'Apa yang salah dengan pertanyaan ini?',
  'aet.home.showComments': 'Tampilkan komentar',
  'aet.home.studentReports': 'laporan siswa',
  'aet.home.placeholderText': 'Harap jelaskan...',
  'aet.home.reportQuestion.notRelevant': 'Tidak relevan',
  'aet.home.reportQuestion.notCorrect': 'Tidak benar',
  'aet.home.reportQuestion.unsafe': 'Tidak aman/berbahaya',
  'aet.home.reportQuestion.somethingElse': 'Sesuatu yang lain',
  'aet.home.StudentDetails.assistedByAI': 'Dibantu oleh AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Tidak ada pelajar yang kesulitan sekarang',
  'aet.home.strugglingStudents.emptyStateDescription': 'Periksa kembali nanti.',
  'aet.home.overallStatus.excelling': 'Sangat bagus',
  'aet.home.overallStatus.fallingBehind': 'Tertinggal',
  'aet.home.overallStatus.keepingUp': 'Mengikuti',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Hanya tampilkan "Pertanyaan sulit"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Hanya tampilkan "Pelajar yang kesulitan"',
  'aet.home.viewQuestionInAssignment': 'Lihat pertanyaan dalam tugas',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Percobaan pertama salah',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Beberapa percobaan salah',
  'aet.home.insightRisk.lowConfidence': 'Kepercayaan diri rendah',
  'aet.home.insightRisk.mediumConfidence': 'Kepercayaan diri sedang',
  'aet.home.insightRisk.lowEngagement': 'Keterlibatan rendah',
  'aet.home.insightRisk.countOfStudents': '{count} dari {total} pelajar',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Pelajar yang kesulitan di sini',
  'aet.home.insightRisk.didNotAttempt': 'Tidak berusaha',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integrasi LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default id;
